"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let PaymentsFilters = class PaymentsFilters extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "PaymentsFilters");
    }
    createAccountGrups(...args) {
        const [accounts] = args;
        const showInactiveAccounts = this.item.showInactiveAccounts;
        return _
            .chain(accounts)
            .groupBy(p => p.owner.id)
            .map((items, owner_id) => ({
            id: owner_id,
            name: items[0].owner.name,
            items: !showInactiveAccounts ? _.filter(items, { inactive: false }) : items
        }))
            .filter(p => p.items.length)
            .value();
    }
    mounted(...args) {
        this.actions.load.trigger(this);
    }
    item;
    accounts;
    async $$load_accounts() {
        return this.$fn.fetch('list_account')
            .then(resp => _.orderBy(resp.data, ['inactive', 'account_type', 'name'], ['asc', 'desc', 'asc']));
    }
    accountGroups;
    async $$load_accountGroups() {
        return this.createAccountGrups(this.$data.accounts);
    }
    ux;
    b_5962862420439144_style;
    dataMembers = ['item', 'accounts', 'accountGroups', 'ux', 'b_5962862420439144_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: {
                    date_from: null,
                    date_to: null,
                    account: null,
                    showInactiveAccounts: false,
                },
                accounts: null,
                accountGroups: null,
                ux: null,
                b_5962862420439144_style: {
                    width: "500px",
                },
            },
        };
    }
    get selectedAccountType() {
        if (this.loaded) {
            return this.item.account && this.item.account.account_type;
        }
        return null;
    }
    get selectedAccount() {
        if (this.loaded) {
            return _.isObject(this.item.account) ? this.item.account : null;
        }
        return null;
    }
    async act_2248226175642056_emit_7894_getActionArgs($event) {
        return {
            event: "submit",
            value: { ...this.item, account: this.item.account?.id },
        };
    }
    async evh_2248226175642056_input_7893_getWhen($event) {
        return !!this.item.date_from;
    }
    async evh_2248226175642056_input(event, scope) {
        return await this.actions.evh_2248226175642056_input.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_setData_7896_getActionArgs($event) {
        return {
            path: "item.date_from",
            value: $event.data[0],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5962862420439144_setData_7898_getActionArgs($event) {
        return {
            path: "item.date_to",
            value: $event.data[1],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5962862420439144_changed(event, scope) {
        return await this.actions.evh_5962862420439144_changed.executeFromDOM(this, event, scope);
    }
    async act_8358196963355853_emit_7900_getActionArgs($event) {
        return {
            event: "submit",
            value: { ...this.item, account: this.item.account?.id },
        };
    }
    async evh_8358196963355853_click(event, scope) {
        return await this.actions.evh_8358196963355853_click.executeFromDOM(this, event, scope);
    }
    async act_6424600534600827_showModal_7902_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                accountId: this.item.account ? this.item.account.id : null,
                transactionKind: "cash_book",
                transactionType: "deposit",
            },
        };
    }
    async evh_6424600534600827_clickPrevent(event, scope) {
        return await this.actions.evh_6424600534600827_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_8249915319319009_showModal_7904_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                accountId: this.item.account ? this.item.account.id : null,
                transactionKind: "cash_book",
                transactionType: "payment",
            },
        };
    }
    async evh_8249915319319009_clickPrevent(event, scope) {
        return await this.actions.evh_8249915319319009_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_2276125547171722_showModal_7906_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                accountId: this.item.account ? this.item.account.id : null,
                transactionKind: this.selectedAccountType === 'bank_account' ? 'bank' : this.selectedAccountType,
            },
        };
    }
    async evh_2276125547171722_clickPrevent(event, scope) {
        return await this.actions.evh_2276125547171722_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_1836715606397834_showModal_7908_getActionArgs($event) {
        return {
            name: "ImportBankStatement",
        };
    }
    async evh_1836715606397834_clickPrevent(event, scope) {
        return await this.actions.evh_1836715606397834_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_2248226175642056_emit_7894 = new core_1.actions.EmitAction({
            actionArgs: this.act_2248226175642056_emit_7894_getActionArgs,
            displayName: "load",
            events: [],
        });
        const evh_2248226175642056_input_7893 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_emit_7894,
            event: "input",
            when: this.evh_2248226175642056_input_7893_getWhen,
            displayName: "load",
        });
        const evh_2248226175642056_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_input_7893],
        });
        const act_5962862420439144_setData_7896 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5962862420439144_setData_7896_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_changed_7895 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_setData_7896,
            event: "changed",
            displayName: "setData",
        });
        const act_5962862420439144_setData_7898 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5962862420439144_setData_7898_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_changed_7897 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_setData_7898,
            event: "changed",
            displayName: "setData",
        });
        const evh_5962862420439144_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_changed_7895, evh_5962862420439144_changed_7897],
        });
        const act_8358196963355853_emit_7900 = new core_1.actions.EmitAction({
            actionArgs: this.act_8358196963355853_emit_7900_getActionArgs,
            displayName: "load",
            events: [],
        });
        const evh_8358196963355853_click_7899 = new core_1.actions.EventHandlerImpl({
            action: act_8358196963355853_emit_7900,
            event: "click",
            displayName: "load",
        });
        const evh_8358196963355853_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8358196963355853_click_7899],
        });
        const act_6424600534600827_showModal_7902 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6424600534600827_showModal_7902_getActionArgs,
            events: [],
        });
        const evh_6424600534600827_clickPrevent_7901 = new core_1.actions.EventHandlerImpl({
            action: act_6424600534600827_showModal_7902,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_6424600534600827_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6424600534600827_clickPrevent_7901],
        });
        const act_8249915319319009_showModal_7904 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8249915319319009_showModal_7904_getActionArgs,
            events: [],
        });
        const evh_8249915319319009_clickPrevent_7903 = new core_1.actions.EventHandlerImpl({
            action: act_8249915319319009_showModal_7904,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_8249915319319009_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8249915319319009_clickPrevent_7903],
        });
        const act_2276125547171722_showModal_7906 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2276125547171722_showModal_7906_getActionArgs,
            events: [],
        });
        const evh_2276125547171722_clickPrevent_7905 = new core_1.actions.EventHandlerImpl({
            action: act_2276125547171722_showModal_7906,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_2276125547171722_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2276125547171722_clickPrevent_7905],
        });
        const act_1836715606397834_showModal_7908 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1836715606397834_showModal_7908_getActionArgs,
            events: [],
        });
        const evh_1836715606397834_clickPrevent_7907 = new core_1.actions.EventHandlerImpl({
            action: act_1836715606397834_showModal_7908,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_1836715606397834_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1836715606397834_clickPrevent_7907],
        });
        return {
            act_2248226175642056_emit_7894,
            evh_2248226175642056_input_7893,
            evh_2248226175642056_input,
            act_5962862420439144_setData_7896,
            evh_5962862420439144_changed_7895,
            act_5962862420439144_setData_7898,
            evh_5962862420439144_changed_7897,
            evh_5962862420439144_changed,
            act_8358196963355853_emit_7900,
            evh_8358196963355853_click_7899,
            evh_8358196963355853_click,
            act_6424600534600827_showModal_7902,
            evh_6424600534600827_clickPrevent_7901,
            evh_6424600534600827_clickPrevent,
            act_8249915319319009_showModal_7904,
            evh_8249915319319009_clickPrevent_7903,
            evh_8249915319319009_clickPrevent,
            act_2276125547171722_showModal_7906,
            evh_2276125547171722_clickPrevent_7905,
            evh_2276125547171722_clickPrevent,
            act_1836715606397834_showModal_7908,
            evh_1836715606397834_clickPrevent_7907,
            evh_1836715606397834_clickPrevent,
            load: act_8358196963355853_emit_7900,
        };
    }
};
PaymentsFilters = __decorate([
    (0, vue_property_decorator_1.Component)()
], PaymentsFilters);
exports.default = PaymentsFilters;
vue_property_decorator_1.Vue.component("PaymentsFilters", PaymentsFilters);
